// Multi-turn Decay (P11) card title (markup #39). For weekly_priority runs
// the source-run context is visible inline so users can tell which run the
// card is showing without cross-referencing the run picker. The "(P11)" code
// is appended by the consumer so it can be rendered as a tooltip trigger.

// The single-run RPC (fn_get_aim_run) omits the runs-list `run_date` column,
// carrying only `started_at` / `created_at` timestamps. Derive `run_date`
// (YYYY-MM-DD) so consumers that read `run.run_date` — the HeadlineMetrics run
// date and AimWhatChangedCard's period labels — match the runs-list shape.
// Idempotent: an existing run_date is left untouched.
/**
 * @param {object|null|undefined} run Run object from the API.
 * @returns {object|null|undefined} Run with a guaranteed run_date when derivable.
 */
export function normalizeAimRun(run) {
  if (!run || typeof run !== 'object') return run;
  if (run.run_date) return run;
  const ts = run.started_at || run.created_at || run.completed_at;
  if (!ts) return run;
  return { ...run, run_date: String(ts).slice(0, 10) };
}

export function fmtFullRunDate(run) {
  if (!run) return '';
  const raw = run.run_date || (run.created_at ? String(run.created_at).slice(0, 10) : '');
  if (!raw) return '';
  const d = new Date(raw + (raw.length === 10 ? 'T00:00:00' : ''));
  if (Number.isNaN(d.getTime())) return raw;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function multiTurnTitle(selectedRun) {
  if (selectedRun?.run_type === 'weekly_priority') {
    const dateStr = fmtFullRunDate(selectedRun);
    // Em-dash separator matches the RunSelector dropdown labels (markup #109).
    return dateStr ? `${dateStr} — Weekly Priority` : 'Weekly Priority';
  }
  return 'Multi-turn Decay';
}
